export default function () {
    return {
        template: require('./tag-create.html'),
        controller,
        controllerAs: 'tagCreateView'
    };

    function controller(tagSwitchService, saveTag, getTagList, $stateParams) {
        const vm = this;

        vm.model = {};
        vm.tagOptions = [];

        vm.saveTag = saveTagFn;
        vm.close = close;

        tagSwitchService.subscribe('load-create', () => {
            vm.model = {};
            getTagListFn();
        });

        function saveTagFn() {
            if (vm.form.$invalid) {
                return;
            }

            saveTag($stateParams.vehicleId, vm.model).then(() => {
                tagSwitchService.publish('load-list');
            });
        }

        function close() {
            tagSwitchService.publish('load-list');
        }

        function getTagListFn() {
            getTagList().then(response => {
                vm.tagOptions = response;
            });
        }
    }
}



// WEBPACK FOOTER //
// ./Client/app/tasks/tags/tagCreateDirective.js